<template>
  <div class="relative" :class="{ activePc: isPc, activeIP: isIP }">
    <div id="app">
      <router-view />
    </div>

    <!-- start bg event -->
    <!-- <div class="fixed bottom-0 left-0 max-w-xs display-non-mobile">
        <img src="@/assets/default_main/godlucky.png" alt="TET image">
    </div>
    <div class="fixed bottom-20 right-0 max-w-xs display-non-mobile">
        <img src="@/assets/default_main/dao.png" alt="TET image">
    </div> -->
    <!-- end bg event -->

    <b-modal centered hide-header hide-footer id="modal-notify">
      <div class="text-center">
          <div class="color-main text-base font-bold mt-3" style="font-family: i Ciel Panton - Black;">
              {{modal.title}}
          </div>
          <div class="color-main text-base mt-3" style="font-family: i Ciel Panton - Black;">
              {{modal.content}}
          </div>
          <div v-if="modal.btnHome" class="color-main2 font-bold text-base mt-3" style="font-family: i Ciel Panton - Black;">
              <button class="bg-main2 text-white font-bold text-center w-full p-2 rounded-md shadow-lg" @click="toHomePage">Trở về trang chủ</button>
          </div>
          <div v-if="modal.btnClose" class="color-main2 font-bold text-base mt-3" style="font-family: i Ciel Panton - Black;">
              <button class="bg-main2 text-white font-bold text-center w-full p-2 rounded-md shadow-lg" @click="toHomePage">Đóng</button>
          </div>
      </div>
    </b-modal>

    <b-modal centered hide-header hide-footer id="modal-vmain-notify">
      <div class="text-center">
          <div class="color-bold-vmain text-base font-bold mt-3" >
              {{modal.title}}
          </div>
          <div class="color-bold-vmain text-base mt-3" >
              {{modal.content}}
          </div>
          <div v-if="modal.btnHome" class="color-main2 font-bold text-base mt-3">
              <button class="bg-main2 text-white font-bold text-center w-full p-2 rounded-md shadow-lg" @click="toHomePageVmain">Trở về trang chủ</button>
          </div>
          <div v-if="modal.btnClose" class="color-main2 font-bold text-base mt-3">
              <button class="bg-main2 text-white font-bold text-center w-full p-2 rounded-md shadow-lg" @click="toHomePageVmain">Đóng</button>
          </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
import subRoute from './router/subRoute'
import { setUtmSource } from '@/utils/auth'

export default {
  name: 'App',
  components: {
    HelloWorld
  },
  data(){
    return {
      isPc: false,
      isIP: false,
      screen_width: 0,
      modal: {
        title: '',
        content: '',
        btnHome: false,
        btnClose: false
      }
    }
  },
  methods: {
    toHomePage(){
      let r = subRoute
      this.$bvModal.hide('modal-notify')
      this.$router.push(r)
    },
    toHomePageVmain(){
      this.$bvModal.hide('modal-vmain-notify')
      this.$router.push('/')
    }
  },
  created(){
    if(screen.width > 440){
      this.isPc = true
    }

    if(navigator.userAgent.match(/(iPad|iPhone|iPod)/g)){
      this.isIP = true
    }
  },
}
</script>

<style>

@media screen and (max-width: 600px) {
  .activeIP .form-control-lg{
    font-size: 16px;
  }
  .activePc{
    /* background-color: rgb(217, 179, 253); */
    padding-left: 0;
    
  }
}

@media screen and (min-width: 600px) {
  .activePc{
    background-color: rgb(239 236 241);
    margin: auto;
    /* padding-left: 40%; */
  }

  .activePc #app{
    background-color: rgb(239 236 241);
    height: 100vh;
    /* max-width: 480px; */
    margin: auto;
    /* padding-left: 40%; */
  }

}

#app {
  font-family: "Be Vietnam Pro";
  /* padding: 15px; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #34404B;
  background-color: white;
}

.color-main {
  color: #862d99;
}

.bg-main2 {
    background-color: #f1674a;
}

</style>
